import gql from 'graphql-tag';

const getSystemStickers = gql`
  query getSystemStickers(
    $offset: Int = 0
    $limit: Int = 150
    $is_active: Boolean = true
    $system_sticker_group: SystemStickerGroupEnum
  ) {
    systemStickers(
      slice: { offset: $offset, limit: $limit }
      is_active: $is_active
      system_sticker_group: $system_sticker_group
    ) {
      total
      records {
        id
        is_active
        asset_image {
          id
          url
        }
      }
    }
  }
`;

export default getSystemStickers;
